import { render, staticRenderFns } from "./PayOrderDetails.vue?vue&type=template&id=4d2c8645&scoped=true"
import script from "./PayOrderDetails.vue?vue&type=script&lang=js"
export * from "./PayOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./PayOrderDetails.vue?vue&type=style&index=0&id=4d2c8645&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2c8645",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d2c8645')) {
      api.createRecord('4d2c8645', component.options)
    } else {
      api.reload('4d2c8645', component.options)
    }
    module.hot.accept("./PayOrderDetails.vue?vue&type=template&id=4d2c8645&scoped=true", function () {
      api.rerender('4d2c8645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PaymentOrder/PayOrderDetails.vue"
export default component.exports